export default __webpack_public_path__ + "static/media/tgIcon.2ea21cc4.svg";